import { render, staticRenderFns } from "./StartSurvey.vue?vue&type=template&id=468c82f5&scoped=true"
import script from "./StartSurvey.vue?vue&type=script&lang=ts"
export * from "./StartSurvey.vue?vue&type=script&lang=ts"
import style0 from "./StartSurvey.vue?vue&type=style&index=0&id=468c82f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468c82f5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VDialog})
